import React from 'react';

class NonAuthLayout extends React.Component {
  componentDidMount() {
    document.body.className = "authentication-bg";
  }
  componentWillUnmount() {
    document.body.className = "";
  }
  render() {
    return <>{this.props.children}</>;
  }
}
export default NonAuthLayout;
